import React, { createContext, useContext, useState, ReactNode } from 'react';
import { ProcessedValidationError } from '../types';

interface ValidationErrorsContextType {
  validationErrors: ProcessedValidationError[];
  setValidationErrors: (errors: ProcessedValidationError[]) => void;
  clearValidationErrors: () => void;
}

const ValidationErrorsContext = createContext<ValidationErrorsContextType | undefined>(undefined);

export const useValidationErrors = () => {
  const context = useContext(ValidationErrorsContext);
  if (context === undefined) {
    throw new Error('useValidationErrors must be used within a ValidationErrorsProvider');
  }
  return context;
};

interface ValidationErrorsProviderProps {
  children: ReactNode;
}

export const ValidationErrorsProvider: React.FC<ValidationErrorsProviderProps> = ({ children }) => {
  const [validationErrors, setValidationErrors] = useState<ProcessedValidationError[]>([]);

  const clearValidationErrors = () => {
    setValidationErrors([]);
  };

  return (
    <ValidationErrorsContext.Provider
      value={{
        validationErrors,
        setValidationErrors,
        clearValidationErrors,
      }}
    >
      {children}
    </ValidationErrorsContext.Provider>
  );
};